/**
 * Functions for determining logged in state
 * This is currently using localStorage
 */

import Cookies from 'js-cookie';
import { UserType } from '@mvrb-frontend/shared-ui';
import jwt from 'jsonwebtoken';

export const getUser = () => {
  return Cookies.getJSON('ORS')?.profile || null;
};

export const getUserId = () => {
  return Cookies.getJSON('ORS') ? Cookies.getJSON('ORS').profile?.id : null;
};

export const isLoggedIn = () => {
  if (Cookies.getJSON('ORS') && Cookies.getJSON('ORS').profile) {
    return true;
  }
  return false;
};

export const isStaffUser = () => {
  return Cookies.getJSON('ORS') ? Cookies.getJSON('ORS').profile?.userType === UserType.Staff : false;
};

export const isAdminUser = () => {
  return Cookies.getJSON('ORS') ? Cookies.getJSON('ORS').profile?.userType === UserType.Admin : false;
};

export const logout = async (timeOut?: boolean) => {
  Cookies.remove('ORS');
  window.location.href = `${window.location.origin}/ors/${timeOut ? 'timeout/:timedout=true' : ''}`;
};

export const userProfile = Cookies.getJSON('ORS') && Cookies.getJSON('ORS').user ? Cookies.getJSON('ORS').user : null;

export const setUserProfileCookie = (accessToken, refreshToken, profile) => {
  const refreshExpiry = jwt.decode(refreshToken).exp;
  Cookies.set(
    'ORS',
    {
      accessToken,
      refreshToken,
      profile,
    },
    {
      expires: new Date(refreshExpiry * 1000),
    },
  );
};

export const updateCookie = async (user: any) => {
  const orsCookie = Cookies.getJSON('ORS');
  const { refreshToken, accessToken, profile } = orsCookie;
  const newProfile = {
    ...user,
    email: profile.email,
    userType: user.userType as UserType,
  };

  const refreshExpiry = jwt.decode(refreshToken).exp;
  setUserProfileCookie(accessToken, refreshToken, newProfile);
};
